const projectData = [
  {
    title: "OH YOGA",
    description: [
      "포스터 업로드 및 다국어 지원(4개 언어) Firebase를 통한 실시간 데이터 관리",
      "앱 다운로드 2,000명 돌파",
      "통한 실시간 데이터 관리 앱 다운로드 2,000명 돌파",
    ],
    imageSrc: "/assets/images/project/ohyoga.png",
    link: "ohyoga",
  },
  {
    title: "Dripptimer",
    description: [
      "포스터 업로드 및 다국어 지원(4개 언어) Firebase를 통한 실시간 데이터 관리",
      "앱 다운로드 2,000명 돌파",
      "통한 실시간 데이터 관리 앱 다운로드 2,000명 돌파",
    ],
    imageSrc: "/assets/images/project/dripcoffee.png",
    link: "dripptimer",
  },
  {
    title: "12dar",
    description: [
      "포스터 업로드 및 다국어 지원(4개 언어) Firebase를 통한 실시간 데이터 관리",
      "앱 다운로드 2,000명 돌파",
      "통한 실시간 데이터 관리 앱 다운로드 2,000명 돌파",
    ],
    imageSrc: "/assets/images/project/12dar.png",
    link: "12dar",
  },
  // Add more data objects for additional projects if needed
];

export default projectData;
